import { VisitOccurrenceStatus } from "@src/appV2/ExperimentalHomeHealth/Cases/types";
import { useVisitOccurrences } from "@src/appV2/ExperimentalHomeHealth/VisitVerification/api/useVisitOccurrences";
import { useIsHomeHealthEnabled } from "@src/appV2/ExperimentalHomeHealth/lib/useIsHomeHealthEnabled";

export function usePendingVisitOccurrenceCount(): number {
  const isHomeHealthEnabled = useIsHomeHealthEnabled();

  const { data } = useVisitOccurrences(
    { filter: { status: VisitOccurrenceStatus.PENDING } },
    { enabled: isHomeHealthEnabled }
  );

  return data?.length ?? 0;
}
